import { useState, useEffect, useCallback } from 'react';
import { createAsyncToken } from '@bingads-webui-universal/primitive-utilities';

/**
 * a custom Hook that will return an auto-canceled async token Creator
 * @param {function} promiseFunc - a function that will return a Promise when it's called
 *  with any args
 * @returns {function} a safe async token creator that will be auto-canceled after a new
 * promise is created or before the Hook wrapper is unmounted
 */
export const useCreateSafeAsyncToken = (promiseFunc) => {
  const [token, setToken] = useState(null);

  useEffect(() => () => token && token.cancel(), [token]);

  return useCallback((...args) => {
    const asyncToken = createAsyncToken(promiseFunc(...args));

    setToken(asyncToken);

    return asyncToken;
  }, [promiseFunc]);
};
